module.exports = __webpack_public_path__ + "static/media/BuiltSmartSlide03.bd8575d4.jpg";